export const ACCESS_TOKEN = "access-token";
export const USER = "user";

export interface UserState {
    pending: boolean;
    isLoggedIn: boolean;
    user: User | null;
    errorMessage?: string | null;
}
